import Bitmap from "../../bitmap";
import Color from "../../models/color";
import { BaseBlockPack } from "./BaseBlockPack";
import { drawStraightBorder } from "./utils/borderUtils";

export default class DefaultBlockPack extends BaseBlockPack {
  drawBlock(
    bit: Bitmap,
    x: number,
    y: number,
    side: number,
    width: number,
    color: Color,
    to: number[]
  ): void {
    this.drawRawBlock(bit, x, y, side, width, color);
    const borderWidth = this.getBorderWidth(width);
    this.drawBlockCorner(bit, x, y, side, width, borderWidth, color, to);
  }

  private drawRawBlock(
    bit: Bitmap,
    x: number,
    y: number,
    side: number,
    width: number,
    color: Color
  ): void {
    let tx: number,
      tl: number,
      rx: number = 0,
      ry: number = 0,
      rw: number = width,
      rh: number = width;

    const bw = this.getBorderWidth(width);

    // Left border
    if (side & 1) {
      drawStraightBorder(bit, x, y, bw, width, color.shade(5));
      rx = bw;
      rw -= bw;
    }
    
    // Top border
    if (side & 2) {
      tx = side & 1 ? x + bw : x;
      bit.drawShape([
        x, y,
        x + width, y,
        x + width, y + bw,
        tx, y + bw
      ], color.shade(5));
      ry = bw;
      rh -= bw;
    }
    
    // Right border
    if (side & 4) {
      tx = side & 2 ? y + bw : y;
      bit.drawShape([
        x + width, y,
        x + width, y + width,
        x + width - bw, y + width,
        x + width - bw, tx
      ], color.shade(3));
      rw -= bw;
    }
    
    // Bottom border
    if (side & 8) {
      tx = side & 1 ? x + bw : x;
      tl = x - tx + width;
      if (side & 4) tl -= bw;
      bit.drawShape([
        x, y + width,
        x + width, y + width,
        tx + tl, y + width - bw,
        tx, y + width - bw
      ], color.shade(3));
      rh -= bw;
    }

    // Draw fill
    if (rw > 0 && rh > 0) {
      this.drawBlockFill(bit, x + rx, y + ry, rw, rh, color);
    }
  }
}

